import { ArrowLeftIcon } from "@heroicons/react/solid";
import React from "react";
import { Link, useParams } from "react-router-dom";
import { blogPosts } from "../blogPosts";

export default function BlogPost() {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <section className="bg-white text-gray-900">
        <div className="container px-5 py-16 mx-auto max-w-3xl text-center">
          <h1 className="text-3xl font-bold title-font mb-4">
            Post not found
          </h1>
          <Link
            to="/blog"
            className="inline-flex items-center text-purple-600 font-medium"
          >
            <ArrowLeftIcon className="w-4 h-4 mr-1" />
            Back to Insights
          </Link>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-white text-gray-900">
      <div className="container px-5 py-16 mx-auto max-w-3xl">
        <Link
          to="/blog"
          className="inline-flex items-center text-purple-600 font-medium mb-8 hover:text-purple-700"
        >
          <ArrowLeftIcon className="w-4 h-4 mr-1" />
          Back to Insights
        </Link>

        <p className="text-purple-600 text-xs uppercase tracking-widest font-semibold mb-3">
          {new Date(post.date).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </p>
        <h1 className="text-3xl sm:text-4xl font-bold title-font text-gray-900 mb-4">
          {post.title}
        </h1>
        <div className="flex flex-wrap gap-1.5 mb-8">
          {post.tags.map((tag) => (
            <span
              key={tag}
              className="text-xs bg-purple-50 text-purple-600 border border-purple-200 rounded-full px-2 py-0.5"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="space-y-5">
          {post.content.map((paragraph, index) => (
            <p key={index} className="text-gray-700 leading-relaxed">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="mt-12 bg-purple-50 border border-purple-100 rounded-xl p-6 text-center">
          <p className="text-gray-900 font-medium mb-3">
            Dealing with something like this on your own platform?
          </p>
          <Link
            to="/#contact"
            className="inline-flex text-white bg-purple-600 border-0 py-2 px-6 hover:bg-purple-700 rounded-full font-medium"
          >
            Talk to an Expert
          </Link>
        </div>
      </div>
    </section>
  );
}
